export const environment = {
  backendUrl: 'https://api.le-compas-dev.compagnons-du-devoir.com',
};
